import _defineProperty2 from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import React from 'react';
import cx from 'classnames';
import isInternalUrl from '@clearscore-group/lib.helpers.is-internal-url';
import { Link } from 'react-router-dom';
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var objectWithoutProperties = createCommonjsModule(function (module) {
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _objectWithoutProperties = /*@__PURE__*/getDefaultExportFromCjs(objectWithoutProperties);
var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var toPrimitive = createCommonjsModule(function (module) {
  var _typeof = _typeof_1["default"];
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var toPropertyKey = createCommonjsModule(function (module) {
  var _typeof = _typeof_1["default"];
  function _toPropertyKey(arg) {
    var key = toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var defineProperty = createCommonjsModule(function (module) {
  function _defineProperty(obj, key, value) {
    key = toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var objectSpread2 = createCommonjsModule(function (module) {
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var _objectSpread = /*@__PURE__*/getDefaultExportFromCjs(objectSpread2);
var styles = {
  "clickableItem": "clickableItem--0ba6e",
  "disabled": "disabled--shpP2",
  "isFullWidth": "isFullWidth--Bq6pL"
};
var _excluded = ["children"],
  _excluded2 = ["Tag"];
var determineAttributes = function determineAttributes(_ref2) {
  var _cx;
  var ariaLabel = _ref2.ariaLabel,
    dataId = _ref2.dataId,
    _ref2$href = _ref2.href,
    _href = _ref2$href === void 0 ? '' : _ref2$href,
    isDisabled = _ref2.isDisabled,
    isFullWidth = _ref2.isFullWidth,
    isNewTab = _ref2.isNewTab,
    onClick = _ref2.onClick,
    _ref2$htmlType = _ref2.htmlType,
    _htmlType = _ref2$htmlType === void 0 ? 'button' : _ref2$htmlType;
  var newTabProps = {
    rel: 'noopener noreferrer',
    target: '_blank'
  };
  var link = _href && _href.startsWith('www.') ? "//".concat(_href) : _href;
  var hasProtocol = link && (link.startsWith('http') || link.startsWith('//'));
  var isInternalLink = link && isInternalUrl(link);
  var isElementLink = link && link.startsWith('#');
  var linkTagType = isInternalLink && !hasProtocol && !isElementLink && !isNewTab ? Link : 'a';
  var Tag = _href ? linkTagType : 'button';
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    Tag: Tag,
    'aria-label': ariaLabel,
    'data-id': dataId,
    'data-qa': 'clickable-item',
    className: cx(styles.clickableItem, (_cx = {}, _defineProperty2(_cx, styles.isFullWidth, isFullWidth), _defineProperty2(_cx, styles.disabled, isDisabled), _cx)),
    to: Tag !== 'a' && _href ? link : ''
  }, Tag === 'a' && isNewTab && newTabProps), Tag === 'a' && !isInternalLink && newTabProps), Tag === 'a' && {
    href: link
  }), Tag === 'button' && {
    type: _htmlType,
    disabled: isDisabled
  }), {
    onClick: onClick
  });
};
var ClickableItem = function ClickableItem(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _determineAttributes = determineAttributes(props),
    Tag = _determineAttributes.Tag,
    attributes = _objectWithoutProperties(_determineAttributes, _excluded2);
  return /*#__PURE__*/React.createElement(Tag, _objectSpread({}, attributes), children);
};
export default ClickableItem;